// Admin'dan keladigan formatlangan matn (CKEditor HTML) uchun oddiy tozalovchi:
// faqat ruxsat etilgan teglar va atributlar qoladi, skript/hodisa atributlari olib tashlanadi.
const ALLOWED_TAGS = new Set([
  "P", "BR", "STRONG", "B", "EM", "I", "U", "S", "A", "UL", "OL", "LI",
  "H2", "H3", "H4", "BLOCKQUOTE", "TABLE", "THEAD", "TBODY", "TR", "TH", "TD",
  "FIGURE", "FIGCAPTION", "IMG", "SPAN", "DIV",
]);
const ALLOWED_ATTRS = { A: ["href", "title"], IMG: ["src", "alt"], TD: ["colspan", "rowspan"], TH: ["colspan", "rowspan"] };

const hasHtml = (s) => /<\/?[a-z][\s\S]*>/i.test(String(s || ""));

function clean(node) {
  Array.from(node.childNodes).forEach((child) => {
    if (child.nodeType === Node.COMMENT_NODE) return child.remove();
    if (child.nodeType !== Node.ELEMENT_NODE) return;
    if (!ALLOWED_TAGS.has(child.tagName)) {
      // ruxsat etilmagan teg: script/style butunlay, boshqalari — ichidagi matn qoladi
      if (["SCRIPT", "STYLE", "IFRAME", "OBJECT", "EMBED"].includes(child.tagName)) return child.remove();
      clean(child);
      child.replaceWith(...child.childNodes);
      return;
    }
    const allowed = ALLOWED_ATTRS[child.tagName] || [];
    Array.from(child.attributes).forEach((attr) => {
      if (!allowed.includes(attr.name)) child.removeAttribute(attr.name);
    });
    if (child.tagName === "A") {
      const href = child.getAttribute("href") || "";
      if (!/^(https?:|mailto:|tel:|\/)/i.test(href.trim())) child.removeAttribute("href");
      child.setAttribute("target", "_blank");
      child.setAttribute("rel", "noopener noreferrer");
    }
    if (child.tagName === "IMG") {
      // faqat http(s) manzilli rasmlar
      if (!/^https?:/i.test((child.getAttribute("src") || "").trim())) return child.remove();
      child.setAttribute("loading", "lazy");
    }
    clean(child);
  });
}

// HTML bo'lsa tozalangan HTML, oddiy matn bo'lsa null (oddiy matn sifatida ko'rsatiladi)
export function sanitizeHtml(value) {
  if (!hasHtml(value)) return null;
  const doc = new DOMParser().parseFromString(`<div>${value}</div>`, "text/html");
  const root = doc.body.firstChild;
  clean(root);
  return root.innerHTML;
}
